var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["base-form", "base-form-" + _vm.formName] },
    [
      _c(
        "VForm",
        { ref: "form", attrs: { errors: _vm.errors, model: _vm.form } },
        [
          _vm.fields.includes("first_name")
            ? _c(
                "VFormItem",
                {
                  staticClass: "base-form--first_name",
                  attrs: { errors: _vm.errors, prop: "data.first_name" }
                },
                [
                  _c("VInput", {
                    attrs: {
                      label: _vm.labels.first_name,
                      placeholder: _vm.placeholders.first_name
                    },
                    model: {
                      value: _vm.form.data.first_name,
                      callback: function($$v) {
                        _vm.$set(_vm.form.data, "first_name", $$v)
                      },
                      expression: "form.data.first_name"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.fields.includes("last_name")
            ? _c(
                "VFormItem",
                {
                  staticClass: "base-form--last_name",
                  attrs: { errors: _vm.errors, prop: "data.last_name" }
                },
                [
                  _c("VInput", {
                    attrs: {
                      label: _vm.labels.last_name,
                      placeholder: _vm.placeholders.last_name
                    },
                    model: {
                      value: _vm.form.data.last_name,
                      callback: function($$v) {
                        _vm.$set(_vm.form.data, "last_name", $$v)
                      },
                      expression: "form.data.last_name"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.fields.includes("phone")
            ? _c(
                "VFormItem",
                {
                  staticClass: "base-form--phone",
                  attrs: { errors: _vm.errors, prop: "data.phone" }
                },
                [
                  _c("VInput", {
                    attrs: {
                      label: _vm.labels.phone,
                      mask: _vm.convertedMask,
                      placeholder: _vm.placeholders.phone,
                      type: "tel",
                      autocomplete: "tel"
                    },
                    model: {
                      value: _vm.form.data.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.form.data, "phone", $$v)
                      },
                      expression: "form.data.phone"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.fields.includes("email")
            ? _c(
                "VFormItem",
                {
                  staticClass: "base-form--email",
                  attrs: { errors: _vm.errors, prop: "data.email" }
                },
                [
                  _c("VInput", {
                    attrs: {
                      label: _vm.labels.email,
                      placeholder: _vm.placeholders.email,
                      type: "email"
                    },
                    model: {
                      value: _vm.form.data.email,
                      callback: function($$v) {
                        _vm.$set(_vm.form.data, "email", $$v)
                      },
                      expression: "form.data.email"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.fields.includes("category_id")
            ? _c(
                "VFormItem",
                {
                  staticClass: "base-form--category_id",
                  attrs: { errors: _vm.errors, prop: "data.category_id" }
                },
                [
                  _c("VSelect", {
                    attrs: {
                      label: "title",
                      label_inp: _vm.labels.cat,
                      "max-height": "100px",
                      options: _vm.directory.categories,
                      placeholder: _vm.placeholders.cat,
                      reduce: function(cat) {
                        return cat.id
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "no-options",
                          fn: function() {
                            return [_c("div")]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      302985487
                    ),
                    model: {
                      value: _vm.form.data.category_id,
                      callback: function($$v) {
                        _vm.$set(_vm.form.data, "category_id", $$v)
                      },
                      expression: "form.data.category_id"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.fields.includes("region_id")
            ? _c(
                "VFormItem",
                {
                  staticClass: "base-form--region_id",
                  attrs: { errors: _vm.errors, prop: "data.region_id" }
                },
                [
                  _c("VSelect", {
                    attrs: {
                      label: "title",
                      label_inp: _vm.labels.city,
                      "max-height": "100px",
                      options: _vm.cities,
                      placeholder: _vm.placeholders.city,
                      reduce: function(city) {
                        return city.id
                      },
                      "search-fn": _vm.getCities
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "no-options",
                          fn: function() {
                            return [
                              _c("div", [
                                _c("p", [
                                  _vm._v(_vm._s(_vm.labels.cityNoOptions))
                                ])
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      817884746
                    ),
                    model: {
                      value: _vm.form.data.region_id,
                      callback: function($$v) {
                        _vm.$set(_vm.form.data, "region_id", $$v)
                      },
                      expression: "form.data.region_id"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.fields.includes("message")
            ? _c(
                "VFormItem",
                {
                  staticClass: "base-form--message",
                  attrs: { errors: _vm.errors, prop: "data.message" }
                },
                [
                  _c("VTextarea", {
                    attrs: { label: _vm.labels.message, rows: "4" },
                    model: {
                      value: _vm.form.data.message,
                      callback: function($$v) {
                        _vm.$set(_vm.form.data, "message", $$v)
                      },
                      expression: "form.data.message"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.fields.includes("company")
            ? _c(
                "VFormItem",
                {
                  staticClass: "base-form--company",
                  attrs: { errors: _vm.errors, prop: "data.company" }
                },
                [
                  _c("VInput", {
                    attrs: {
                      label: _vm.labels.company,
                      placeholder: _vm.placeholders.company
                    },
                    model: {
                      value: _vm.form.data.company,
                      callback: function($$v) {
                        _vm.$set(_vm.form.data, "company", $$v)
                      },
                      expression: "form.data.company"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.fields.includes("role_id")
            ? _c(
                "VFormItem",
                {
                  staticClass: "base-form--role_id",
                  attrs: { errors: _vm.errors, prop: "data.role_id" }
                },
                [
                  _c("VSelect", {
                    attrs: {
                      label: "title",
                      label_inp: _vm.labels.role,
                      "max-height": "100px",
                      options: _vm.directory.roles,
                      placeholder: _vm.placeholders.role,
                      reduce: function(role) {
                        return role.id
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "no-options",
                          fn: function() {
                            return [_c("div")]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      302985487
                    ),
                    model: {
                      value: _vm.form.data.role_id,
                      callback: function($$v) {
                        _vm.$set(_vm.form.data, "role_id", $$v)
                      },
                      expression: "form.data.role_id"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("VFormErrorsUnlinked", {
        attrs: {
          errors: _vm.errors,
          "form-children": _vm.$refs.form ? _vm.$refs.form.$children : []
        }
      }),
      _vm._v(" "),
      _vm.$slots.agree
        ? _c(
            "div",
            { staticClass: "agree" },
            [
              _c("VCheckbox", {
                attrs: { id: _vm.agreeId, error: !_vm.agree },
                model: {
                  value: _vm.agree,
                  callback: function($$v) {
                    _vm.agree = $$v
                  },
                  expression: "agree"
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "sub-text", attrs: { for: _vm.agreeId } },
                [_vm._t("agree")],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "base-form--submit-button" }, [
        _c(
          "button",
          {
            staticClass: "button button-primary",
            attrs: { disabled: _vm.disableSend },
            on: { click: _vm.sendForm }
          },
          [_vm._v("\n      " + _vm._s(_vm.labels.buttonSubmit) + "\n    ")]
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "sub-text" }, [
        _vm._v("\n    " + _vm._s(_vm.labels.requireText) + "\n  ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }